import { createAction } from "@reduxjs/toolkit";

export const setPeriod = createAction('period/setPeriod');